export const GET_CREDENTIALS = 'GET_CREDENTIALS';
